module.exports = __webpack_public_path__ + "static/banner_bg-7cd5265357726d80258c5d0090487b3b.png";